import * as request from "superagent";
import { APIError, StringAttribute, ObjectAttribute, DateTimeAttribute } from "../types"
import {without} from "lodash"

const defaultApiUrl = "/api/form-types"

export class FormType {

  static get = (id:number, resourceUrl?:string):Promise<FormType> => {
    if(!resourceUrl) {
      resourceUrl = defaultApiUrl
    }
    let p = new Promise<FormType>((resolve,reject) => {
      //Perform get here
      request.get(resourceUrl + "/" + id.toString()).then((response)=>{
        if(!response.ok){
          const apiErr = new APIError()
          apiErr.type = "api"
          apiErr.message = response.body.toString()
          reject(apiErr)
        } else {
          resolve(new FormType(response.body))
        }
      }).catch((err)=>{
        const apiErr = new APIError()
        apiErr.type = "http"
        apiErr.message = (err.response || {text: err.toString()}).text
        reject(apiErr)
      })
    });

    p.catch((err:any)=>{
        if (err.message && err.message == "Unauthorized") {
            // If our session times out, ask the user to login again, rather than failing until they figure out to refresh
            window.location.href = "/login"
        }
    })

    return p 
  }

  static query = (q:any, resourceUrl?:string):Promise<Array<FormType>> => {
    if(!resourceUrl) {
      resourceUrl = defaultApiUrl
    }
    resourceUrl += "?filter=" + encodeURIComponent(JSON.stringify(q))
    let p = new Promise<Array<FormType>>((resolve,reject) => {
      //Perform query here
      request.get(resourceUrl as string).then((response)=>{
        if(!response.ok){
          const apiErr = new APIError()
          apiErr.type = "api"
          apiErr.message = response.body.toString()
          reject(apiErr)
        } else {
          const data = new Array<FormType>()
          if(response.body){
            for (var i of response.body) {
                data.push(new FormType(i))
            }
          }
          resolve(data)
        }
      }).catch((err)=>{
        const apiErr = new APIError()
        apiErr.type = "http"
        apiErr.message = (err.response || {text: err.toString()}).text
        reject(apiErr)
      })
    });

    p.catch((err:any)=>{
        if (err.message && err.message == "Unauthorized") {
            // If our session times out, ask the user to login again, rather than failing until they figure out to refresh
            window.location.href = "/login"
        }
    })

    return p 
  }

  // Model Attributes
 
  key: StringAttribute;  
  title: StringAttribute;  
  baseDefinition: ObjectAttribute;  
  userAttributes: ObjectAttribute;  
  extendedAttributes: ObjectAttribute;  
  createdAt: DateTimeAttribute;  
  createdBy: StringAttribute;  
  updatedAt: DateTimeAttribute;  
  updatedBy: StringAttribute; 
  _transactionQueue: Array<Promise<FormType>>;

  constructor(data?:any) { 
    if(!data){
        data = {}
    }
     
    this.key = new StringAttribute(data.key);  
    this.title = new StringAttribute(data.title);  
    this.baseDefinition = new ObjectAttribute(data.baseDefinition ? data.baseDefinition : {});  
    this.userAttributes = new ObjectAttribute(data.userAttributes ? data.userAttributes : {});  
    this.extendedAttributes = new ObjectAttribute(data.extendedAttributes ? data.extendedAttributes : {});  
    this.createdAt = new DateTimeAttribute(data.createdAt);  
    this.createdBy = new StringAttribute(data.createdBy);  
    this.updatedAt = new DateTimeAttribute(data.updatedAt);  
    this.updatedBy = new StringAttribute(data.updatedBy); 
    
    this._transactionQueue = new Array<Promise<FormType>>();
  }

  get modelData():any{
      return this.getModelData()
  }

  public getModelData():any {
    var d:any = {}  
    if(this.key) {
      d.key = this.key.value
    }
     
    if(this.title) {
      d.title = this.title.value
    }
     
    if(this.baseDefinition) {
      d.baseDefinition = this.baseDefinition.value
    }
     
    if(this.userAttributes) {
      d.userAttributes = this.userAttributes.value
    }
     
    if(this.extendedAttributes) {
      d.extendedAttributes = this.extendedAttributes.value
    }
     
    if(this.createdAt) {
      d.createdAt = this.createdAt.value
    }
     
    if(this.createdBy) {
      d.createdBy = this.createdBy.value
    }
     
    if(this.updatedAt) {
      d.updatedAt = this.updatedAt.value
    }
     
    if(this.updatedBy) {
      d.updatedBy = this.updatedBy.value
    }
    

    return d
  }

  validate = ():Promise<boolean> => {
    return new Promise((resolve,reject) => {
      //Perform validation here
    });
  }

  save = (resourceUrl?:string):Promise<FormType> => {
    var self = this
    let pFn = (resolve:any,reject:any) => {
      if(!resourceUrl) {
        resourceUrl = defaultApiUrl
      }
      // TODO: jdouglas Add validations to generator Tue Dec 12 09:58:59 2017


      if(!self.key){


        request.post(resourceUrl).send(self.modelData).then((response)=>{

          // we should never get text/html unless we are getting redirected to login by the server
          if(response.type === "text/html"){
            window.location.href = "/login"
          }
          
          if(!response.ok){
            const apiErr = new APIError()
            apiErr.type = "api"
            apiErr.message = response.body.toString()
            reject(apiErr)
          } else {


            this.key.value = response.body.key
 
              
            resolve(new FormType(response.body))
          }
        }).catch((err:any)=>{
           const apiErr = new APIError()
            apiErr.type = "http"
            apiErr.message = (err.response || {text: err.toString()}).text
            reject(apiErr)
        })
      } else {

        request.put(resourceUrl + "/" + this.key).send(this.modelData).then((response)=>{


          if(!response.ok){
            const apiErr = new APIError()
            apiErr.type = "api"
            apiErr.message = response.body.toString()
            reject(apiErr)
          } else {
            
            resolve(new FormType(response.body))
          }
        }).catch((err:any)=>{
           const apiErr = new APIError()
            apiErr.type = "http"
            apiErr.message = (err.response || {text: err.toString()}).text
            reject(apiErr)
        })
      }
    }
    
    var p:Promise<FormType>

    if(self._transactionQueue.length == 0){
        //console.log("Stack Empty")
        // If there are not outstanding transactions, just go ahead and create the promise
        // with pFn, adding the reject/resolve code to remove the item from the list.
        p = new Promise(pFn)

    } else {

        //console.log("Stack has " + self._transactionQueue.length + " items")
        const lastItem =self._transactionQueue[self._transactionQueue.length -1 ]
        // If there are outstanding transactions, listen for the completion of the last one, prior to initiating self one.
        p = new Promise((resolve, reject) => {
            lastItem.then((result:any) => {
                pFn(resolve, reject)
            }).catch((reason:any) => {
                pFn(resolve, reject)
            })
        })

    }

    self._transactionQueue.push(p)
    //console.log("Stack raised to " + self._transactionQueue.length + " items")

    // self is where we will recognize that a promise has concluded and remove it from the queue
    p.then(()=>{
        self._transactionQueue = without(self._transactionQueue, p)
        //console.log("Stack reduced to " + self._transactionQueue.length + " items")
    })
    .catch((err:any)=>{
        if (err.message && err.message == "Unauthorized") {
            // If our session times out, ask the user to login again, rather than failing until they figure out to refresh
            window.location.href = "/login"
        }
        self._transactionQueue = without(self._transactionQueue, p)
        //console.log("Stack reduced to " + self._transactionQueue.length + " items")
    })

    return p
    

  }
 
  delete = (resourceUrl?:string):Promise<FormType> => {
    return new Promise((resolve,reject) => {
      if(!resourceUrl) {
        resourceUrl = defaultApiUrl
      }
      // TODO: jdouglas Add validations to generator Tue Dec 12 09:58:59 2017

      if(!this.key){

        const apiErr = new APIError()
        apiErr.type = "api"
        apiErr.message = "ID Required to delete"
        reject(apiErr)
      } else {

        request.delete(resourceUrl + "/" + this.key).send(this.modelData).then((response)=>{

          if(!response.ok){
            const apiErr = new APIError()
            apiErr.type = "api"
            apiErr.message = response.body.toString()
            reject(apiErr)
          } else {
            resolve(this)
          }
        }).catch((err:any)=>{
            const apiErr = new APIError()
            apiErr.type = "api"
            apiErr.message = err.message 
            reject(apiErr)
        })
      }
    });
  }

}

export default FormType 
